import { render, staticRenderFns } from "./Online.vue?vue&type=template&id=1bffa0ae&"
import script from "./Online.vue?vue&type=script&lang=js&"
export * from "./Online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports